import axios from "axios";

let baseUrl = "https://www.tipddy.cl/wp-json/v2/public";



export const fetchClientsIds = async ({ token }) => {
  try {
    let { data } = await axios.get(`${baseUrl}/clients`, {
      headers: {
        Authorization: `Bearer ${token}}`,
      },
    });
    return data.result;
  } catch (err) {
    throw new Error(err);
  }
};

export const fetchConfig = async ({ id, token }) => {
  try {
    let { data } = await axios.get(`${baseUrl}/client/${id}`, {
      headers: {
        Authorization: `Bearer ${token}}`,
      },
    });
    console.log(data.result);
    return data.result;
  } catch (err) {
    throw new Error(err);
  }
};

export const fetchClientAndToken = async (id = false) => {
  console.log(window.location.host);

  try {
    let response = await axios.get(`${baseUrl}/client/tk`, {
      timeout: 10000,
      headers: {
        "Content-type": "application/json",
      },
      params: {
        domain: "https://aulavirtual.colegioezer.cl/", //localhost:3000", // window.location.host,
        id: id,
      },
    });
    console.log(response.data.result);
    return response.data.result;
  } catch (err) {
    throw new Error(err);
  }
};
